<template>
  <nav>
    <v-toolbar flat color="white">
      <v-toolbar-title class="secondary--text font-weight-medium">
        Provider Portal
      </v-toolbar-title>
      <v-spacer />
      <router-link :to="{ name: 'Provider-Dashboard' }">
        <v-btn flat>My Listings</v-btn>
      </router-link>
      <v-btn flat @click="logout">Log Out</v-btn>
    </v-toolbar>
    <v-divider />
  </nav>
</template>

<script>
export default {
  name: "ProviderNav",
  methods: {
    logout() {
      this.$store.commit("assignProviderToken", "");
      this.$router.push({ name: "Provider-Login" });
    }
  }
};
</script>
